import React, { useState } from 'react';
import axios from 'axios';

const RegistrationForm = () => {
    const [formData, setFormData] = useState({
        admin_first_name: '', admin_last_name: '', admin_email: '',
        admin_password: '', society_name: '', subdomain: ''
    });
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === 'subdomain' ? value.toLowerCase().replace(/[^a-z0-9]/g, '') : value;
        setFormData(prev => ({ ...prev, [name]: processedValue }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setError(null);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL || 'https://apartix-test.onrender.com'}/api/societies/register/`, formData);
            setMessage(response.data);
            setFormData({
                admin_first_name: '', admin_last_name: '', admin_email: '',
                admin_password: '', society_name: '', subdomain: ''
            });
        } catch (err) {
            const errorData = err.response?.data;
            const errorMessages = errorData ? Object.entries(errorData).map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : val}`).join(' ') : 'Could not connect to server.';
            setError(errorMessages);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
            <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg">
                <h2 className="text-3xl font-bold text-center text-gray-900 mb-2">Register Your Society</h2>
                <p className="text-center text-gray-500 mb-6">Create your dedicated workspace in seconds.</p>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <input type="text" name="admin_first_name" value={formData.admin_first_name} onChange={handleChange} placeholder="Admin First Name" required className="p-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                        <input type="text" name="admin_last_name" value={formData.admin_last_name} onChange={handleChange} placeholder="Admin Last Name" required className="p-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div className="mb-4">
                        <input type="email" name="admin_email" value={formData.admin_email} onChange={handleChange} placeholder="Admin Email" required className="p-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div className="mb-4">
                        <input type="password" name="admin_password" value={formData.admin_password} onChange={handleChange} placeholder="Password" required className="p-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <hr className="my-6 border-t" />
                    <div className="mb-4">
                        <input type="text" name="society_name" value={formData.society_name} onChange={handleChange} placeholder="Society Name (e.g., Uniso Apartments)" required className="p-3 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="subdomain" className="text-sm font-medium text-gray-700 block mb-1">Choose your workspace URL:</label>
                        <div className="flex items-center">
                            <input type="text" id="subdomain" name="subdomain" value={formData.subdomain} onChange={handleChange} placeholder="uniso" required className="p-3 border border-gray-300 rounded-l-lg w-full focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                            <span className="p-3 bg-gray-100 text-gray-600 rounded-r-lg border border-l-0 border-gray-300">.apartix.com</span>
                        </div>
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-indigo-600 text-white p-3 rounded-lg font-semibold hover:bg-indigo-700 disabled:bg-indigo-400">
                        {loading ? 'Creating Workspace...' : 'Create Society'}
                    </button>
                </form>
                {message && <div className="mt-4 p-4 bg-green-100 text-green-800 rounded-lg"><h3 className="font-bold">{message.message}</h3><p>Access it here: <a href={message.access_url} target="_blank" rel="noopener noreferrer" className="underline">{message.access_url}</a></p></div>}
                {error && <div className="mt-4 p-4 bg-red-100 text-red-800 rounded-lg"><p className="font-bold">Error:</p><p>{error}</p></div>}
            </div>
        </div>
    );
};
export default RegistrationForm;
